import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _AutoscaleLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M8.77 9 6 12m0 0 2.77 3M6 12h12m0 0-2.77-3M18 12l-2.77 3" }), _jsx("path", { stroke: "currentColor", d: "M3 2v20M21 2v20" })] }) });
}
const AutoscaleLightCustom = forwardRef(_AutoscaleLightCustom);
export { AutoscaleLightCustom };
